import { gql } from 'graphql-request'

export const CREATE_GAME_GOLD_MINER = gql`
  mutation CREATE_GAME_GOLD_MINER($timesBet: Int!) {
    createGameGoldMiner(timesBet: $timesBet) {
      status
      error
      data {
        userId
        giftIdEarning
        valueGift
        quantity
        newCoins
        imgGift
        iconGift
        imgGiftFrame
        giftName
        status
      }
    }
  }
`
